module.exports = __webpack_public_path__ + "static/media/first_single_layer.285437db.png";